import React from "react";

const LocationsContext = React.createContext();

export const LocationsProvider = LocationsContext.Provider;
export const LocationsConsumer = LocationsContext.Consumer;
export default LocationsContext;
